/**
 * Rotas do domínio CREObras (R5, T102, DOM-16).
 *
 * Extraídas de `src/router/rotas/ProjetosEngenharia.ts` (que deixou de
 * existir — ao contrário de `Fabricacao.ts`, que é hub de OUTRO domínio,
 * `ProjetosEngenharia.ts` era só o arquivo de rota do próprio CREObras, sem
 * nada de outro domínio para deixar para trás). `obra` espalha dentro de
 * `/:obra/cre` (LayoutObra, via `router/rotas/Obra.ts`); `geral` espalha na
 * raiz `/cre` (LayoutGeral, via `router/rotas/Geral.ts`) — mesmo formato de
 * `views/CREFabrica`'s `creFabricaRotas.ts` (par `geral`/`obra`).
 *
 * `ListarDashboardGeralObra.vue` é consumido por CREFabrica também
 * (compartilhado de verdade — decide o que buscar pelo próprio
 * `route.name`) e por isso está no barrel (`index.ts`).
 */
const metaPadrao = {
  subject: ["PROJETO"],
  action: ["read"],
  showMenu: true,
  grupo: "CRE",
  grupoTitle: "CRE",
};

const rotas = {
  geral: [
    {
      path: "/cre",
      name: "CRE - GERAL",
      component: () => import("./DashboardGeral.vue"),
      meta: {
        breadcrumb: "",
        title: "CRE - GERAL",
        icon: "mdi-text-box-multiple-outline",
        ...metaPadrao,
      },
    },

    {
      path: "/cre/Dashboard",
      name: "CRE Dashboard",
      component: () => import("./ListarDashboardGeralObra.vue"),
      meta: {
        breadcrumb: "",
        title: "CRE Dashboard",
        icon: "mdi-view-dashboard-outline",
        ...metaPadrao,
        action: ["admin_projetos"],
      },
    },
    {
      path: "/cre/AsBuilt",
      name: "As Built Geral",
      component: () => import("./DashboardGeral.vue"),
      meta: {
        breadcrumb: "CRE - GERAL",
        title: "As Built",
        icon: "mdi-hexagon-multiple",
        query: { categoria: "AsBuilt" },
        ...metaPadrao,
      },
    },
    {
      path: "/cre/Executivo",
      name: "Executivo Geral",
      component: () => import("./DashboardGeral.vue"),
      meta: {
        breadcrumb: "CRE - GERAL",
        title: "Executivo",
        icon: "mdi-hexagon-slice-1",
        ...metaPadrao,
        query: { categoria: "Executivo" },
      },
    },
    {
      path: "/cre/Referencia",
      name: "Referência Geral",
      component: () => import("./DashboardGeral.vue"),
      meta: {
        breadcrumb: "CRE - GERAL",
        title: "Referência",
        icon: "mdi-text-box",
        query: { categoria: "Referencia" },
        subject: ["PROJETO"],
        action: ["readInterno"],
        showMenu: true,
        grupo: "CRE",
        grupoTitle: "CRE",
      },
    },
  ],
  obra: [
    {
      path: "cre/Dashboard",
      name: "CRE Dashboard Obra",
      component: () => import("./ListarDashboardGeralObra.vue"),
      meta: {
        breadcrumb: "",
        title: "CRE Dashboard Obra",
        icon: "mdi-view-dashboard-outline",
        subject: ["PROJETO"],
        action: ["readInterno"],
        showMenu: true,
        grupo: "CRE",
        grupoTitle: "CRE",
      },
    },
    {
      path: "cre",
      name: "Projetos de obra",
      component: () => import("./DashboardObra.vue"),
      meta: {
        breadcrumb: "",
        title: "Projetos de obra",
        icon: "mdi-text-box-multiple-outline",
        ...metaPadrao,
      },
    },
    {
      path: "cre/AsBuilt",
      name: "As Built",
      component: () => import("./DashboardObra.vue"),
      meta: {
        breadcrumb: "Projetos de obra",
        title: "As Built",
        icon: "mdi-hexagon-multiple",
        query: { categoria: "AsBuilt" },
        ...metaPadrao,
      },
    },
    {
      path: "cre/Executivo",
      name: "Executivo",
      component: () => import("./DashboardObra.vue"),
      meta: {
        breadcrumb: "Projetos de obra",
        title: "Executivo",
        icon: "mdi-hexagon-slice-1",
        query: { categoria: "Executivo" },
        ...metaPadrao,
      },
    },
    {
      path: "cre/Referencia",
      name: "Referência",
      component: () => import("./DashboardObra.vue"),
      meta: {
        breadcrumb: "Projetos de obra",
        title: "Referência",
        icon: "mdi-text-box",
        query: { categoria: "Referencia" },
        subject: ["PROJETO"],
        action: ["readInterno"],
        showMenu: true,
        grupo: "CRE",
        grupoTitle: "CRE",
      },
    },
  ],
};
export default rotas;
